const PACKAGE_JSON = require(`../../../package.json`)

const { version } = PACKAGE_JSON

// eslint-disable-next-line import/prefer-default-export
const getRelease = () => `client@${version}`

module.exports = {
  getRelease,
}
